<div class="service-request-selector-dialog">
    <h2 mat-dialog-title>{{ dialogTitle }}</h2>

    <mat-dialog-content>
        <p class="mat-body-1 dialog-hint" *ngIf="dialogHint">{{ dialogHint }}</p>

        <form [formGroup]="selectorForm" class="selector-form">
            <!-- Category Field -->
            <mat-form-field *ngIf="showCategoryField" appearance="outline" floatLabel="always" class="full-width">
                <mat-label>Service Request Category</mat-label>
                <input type="text" matInput formControlName="category" [matAutocomplete]="categoryAuto"
                    placeholder="Search for a category...">
                <mat-hint>Start typing to search for categories (e.g., Laboratory, Imaging, Consultation)</mat-hint>
                <mat-icon matSuffix *ngIf="loadingCategories">
                    <span class="spinner-border spinner-border-sm"></span>
                </mat-icon>
                <mat-autocomplete #categoryAuto="matAutocomplete" [displayWith]="displayOption">
                    <mat-option *ngFor="let option of filteredCategoryOptions; trackBy: trackByCode" [value]="option">
                        <strong>{{ option.display }}</strong>
                        <span class="text-muted" *ngIf="option.code"> ({{ option.code }})</span>
                    </mat-option>
                    <mat-option disabled *ngIf="filteredCategoryOptions.length === 0">
                        No categories found. Try a different search term.
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <!-- Service Request Code Field -->
            <mat-form-field *ngIf="showCodeField" appearance="outline" floatLabel="always" class="full-width">
                <mat-label>Service Request Code</mat-label>
                <input type="text" matInput formControlName="serviceRequestCode" [matAutocomplete]="serviceRequestAuto"
                    placeholder="Search for a service...">
                <mat-hint>Start typing to search for specific services (e.g., Blood Test, X-Ray, ECG)</mat-hint>
                <mat-icon matSuffix *ngIf="loadingServiceRequests">
                    <span class="spinner-border spinner-border-sm"></span>
                </mat-icon>
                <mat-autocomplete #serviceRequestAuto="matAutocomplete" [displayWith]="displayOption">
                    <mat-option *ngFor="let option of filteredServiceRequestOptions; trackBy: trackByCode"
                        [value]="option">
                        <strong>{{ option.display }}</strong>
                        <span class="text-muted" *ngIf="option.code"> ({{ option.code }})</span>
                        <span *ngIf="option.active === true" [appEmphasis]="'success'" fontSize="11px">Available</span>
                    </mat-option>
                    <mat-option disabled *ngIf="filteredServiceRequestOptions.length === 0">
                        No service codes found. Try a different search term.
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">
            <mat-icon>close</mat-icon>
            Cancel
        </button>
        <button mat-flat-button color="primary" (click)="save()" [disabled]="!selectorForm.valid">
            <mat-icon>check</mat-icon>
            Save
        </button>
    </mat-dialog-actions>
</div>